import { TReduxActions } from '../../types/redux';
import { ETab } from '../../types/tab';
import { ETabActionTypes } from '../../actions/tabs';

export const defaultTabState = ETab.Reviews;

export function tabsReducer(state: ETab = defaultTabState, action: TReduxActions) {
  switch (action.type) {
    case ETabActionTypes.SetActiveTab: {
      return action.payload;
    }

    default:
      return state;
  }
}
